// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class FamilyAttributor extends StyleAttributor {
    public add(node: HTMLElement, value: string) {
        // we need to wrap quotes around fonts because for some odd reason if you have a font that has
        // a number in it (such as Slabo 27px), the browser (at least chrome) refuses to use it unless
        // it has quotes around it.
        const quoted = `"${value}"`;
        if (!super.canAdd(node, quoted)) {
            return false;
        }
        return super.add(node, quoted);
    }

    public value(node: HTMLElement): string {
        return super.value(node).replace(/["]/g, '');
    }
}

// @ts-ignore
export default new FamilyAttributor('fontFamily', 'font-family', { scope: Scope.INLINE, whitelist: null });
// @ts-ignore
export const BlockFamilyAttributor = new FamilyAttributor('blockFontFamily', 'font-family', { scope: Scope.BLOCK });
